import contractHttpRequestInstance from '../http_requests/contract/contract_http_requests';

const addUserToContract = (
   contractId: string,
   userId: string,
   observer: { userAddedToContract: Function; userAddedToContractError: Function }
) => {
   contractHttpRequestInstance.addUser(contractId, userId, {
      success:(contractMessage: any) => {
         observer.userAddedToContract(contractMessage);
      },
      failure: (error: any) => {
         observer.userAddedToContractError(error);
      }
   });
};

export default addUserToContract;
